
          import { UIComponents } from 'Theme'
          export default {
            ...UIComponents
          }
        